import React from 'react';
import './ButtonSoundCloud.css';

const ButtonSoundCloud = (props) =>{
    return (
        <a className="button-soundcloud" href='https://soundcloud.com/jozefdeville' target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68.17 38.34"><g id="aa38f9bd-f334-42b9-bc20-799a09f264bd" data-name="Layer 2"><g id="ed6c2e0c-b23a-4e5d-89ea-bf4749f54020" data-name="Layer 5"><path d="M57.52,17a10.78,10.78,0,0,0-2.22.23A19.21,19.21,0,0,0,36.21,0a2.13,2.13,0,0,0-2.13,2.13V36.21a2.13,2.13,0,0,0,2.13,2.13H57.52a10.65,10.65,0,0,0,0-21.3Z" fill="#fff"/><path d="M25.56,6.39V36.21a2.13,2.13,0,1,0,4.26,0V6.39a2.13,2.13,0,1,0-4.26,0Z" fill="#fff"/><path d="M17,14.91v21.3a2.13,2.13,0,1,0,4.26,0V14.91a2.13,2.13,0,1,0-4.26,0Z" fill="#fff"/><path d="M8.52,36.21a2.13,2.13,0,1,0,4.26,0V14.91a2.13,2.13,0,1,0-4.26,0Z" fill="#fff"/><path d="M2.13,38.34a2.13,2.13,0,0,0,2.13-2.13V23.43a2.13,2.13,0,0,0-4.26,0V36.21A2.13,2.13,0,0,0,2.13,38.34Z" fill="#fff"/></g></g></svg>
        
        </a>
    )
}

export default ButtonSoundCloud